/*
* @描述: 打卡记录详情
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025/3/22 10:34
*/
<template>
    <van-popup v-model="dialogVisible"
               :style="{ width: '100%',height: '100vh' }"
               position="bottom">
        <div v-loading="loading" class="public_container">
            <div class="returnNavBar">
                <ReturnNavBar :isAllFunctions="false"
                              :isCustomReturnEvent="true"
                              :isTitleNormal="true"
                              title="返回"
                              @returnEvent="handleDialogClose"></ReturnNavBar>
            </div>
            <div class="detail_wrap_container">
                <ul class="detail_list">
                    <li v-for="(item, index) in detailRecordList" class="detail_list_item">
                        <p v-if="index === 0" class="item_title"
                           v-text="detailRecordList.length > 1 ?'开始时间' : '打卡时间'"></p>
                        <p v-else-if="index === detailRecordList.length - 1 && detailRecordList.length > 1"
                           class="item_title">
                            结束时间{{ item.is_skip ? "（无需打卡）" : "" }}
                        </p>
                        <p v-else></p>
                        <template v-if="!item.is_skip">
                            <div class="list_time"><i class="iconfont icon-shijian"></i>{{ item.punch_at_show }}</div>
                            <div><i class="iconfont icon-weizhi1"></i>{{ item.address || item.address_end }}</div>
                            <div v-if="item.images && item.images.length">
                                <ul class="voucher_list">
                                    <li v-for="(img, imgIndex) in item.images" :key="imgIndex" class="voucher_item">
                                        <el-image :preview-src-list="item.images"
                                                  :src="img"
                                                  alt=""></el-image>
                                    </li>
                                </ul>
                            </div>
                            <div>{{ item.remark }}</div>
                        </template>
                    </li>
                </ul>
            </div>
        </div>
    </van-popup>
</template>
<script>

import {getAdminIndividualAttendanceCheckDetail} from "@/api";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";

export default {
    name: "checkRecordDetail",
    components: {ReturnNavBar},
    data() {
        return {
            loading: false,
            detailRecordList: []
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        check_record_id: {
            type: [Number, String],
            default: 0
        },
    },
    created() {
        if (this.check_record_id) {
            this.loading = true
            getAdminIndividualAttendanceCheckDetail({
                id: this.check_record_id
            }).then(res => {
                if (res.code === 200) {
                    let detailRecordList = [];
                    if (res.data.punch_type === "SINGLE") {
                        detailRecordList.push(res.data);
                    } else {
                        detailRecordList = [
                            {punch_type: res.data.punch_type, ...res.data.start},
                            {punch_type: res.data.punch_type, ...res.data.end},
                        ]
                    }
                    this.detailRecordList = detailRecordList
                    this.loading = false
                }
            })
        }
    },
    mounted() {
    },
    methods: {
        handleDialogClose() {
            this.$emit('update:dialogVisible', false)
        }
    },
}
</script>
<style lang="scss" scoped>
.detail_wrap_container{
    padding: 10px 16px;
}
.detail_list {
    .detail_list_item {
        width: 100%;
        padding-left: 10px;
        padding-bottom: 16px;
        box-sizing: border-box;
        position: relative;

        &::before {
            width: 6px;
            height: 6px;
            opacity: 1;
            border-radius: 50%;
            content: " ";
            left: 0;
            top: 6px;
            position: absolute;
            background: rgba(41, 144, 255, 1);
            z-index: 10;
        }

        &::after {
            width: 1px;
            height: 100%;
            position: absolute;
            left: 2.5px;
            top: 6px;
            background-color: rgba(0, 0, 0, 0.08);
            content: " ";
        }

        .item_title {
            font-size: 12px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 18px;
            color: rgba(153, 153, 153, 1);
            margin-bottom: 12px;
        }

        .iconfont {
            font-size: 14px;
            color: rgba(102, 102, 102, 1);
            margin-right: 4px;
        }

        & > div {
            & + div {
                margin-top: 8px;
            }

            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(102, 102, 102, 1);
        }

        .list_time {
            font-weight: 700;
            color: rgba(51, 51, 51, 1);
        }
    }
}

.voucher_list {
    display: flex;
    gap: 8px;

    .voucher_item {
        width: 44px;
        height: 44px;
        cursor: pointer;
        position: relative;
        text-align: center;
        border-radius: 4px;

        .el-image {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
}
</style>